import React from 'react';
import { IEventResultStore, getSportClassByPresentationId, StatisticsInApi } from 'eTip--common';
import {
    CategoryIcon, OtherEventResults, EventResults, ILiveEventcompetitor as ILiveEventCompetitor, IMainResult,
    IEventAction, EventActions, EventActionItem
} from 'common--design-library';

import { translation } from 'easit--localization';
import * as classNames from 'classnames';


export interface ILiveEventDetailHeaderProps {
    eventId: number;
    actions: IEventAction[];
    categoryBreadcrumbs: string;
    competitors: ILiveEventCompetitor[];
    graphicsPresentationId: number;
    eventTime?: number;
    importantResults: IEventResultStore[];
    isFavorite?: boolean;
    hasResults: boolean;
    mainResult: IMainResult;
    stateName: string;
    otherResults: IEventResultStore[];
    onLiveStreamClick: () => void | null;
    onMatchTrackerClick: () => void | null;
    canShowLiveStreamIcon: boolean;
    canShowMatchTrackerIcon: boolean;
    onGoToEventDetail: () => void;
    onToggleActions?: (isActionsExpanded: boolean) => void;

    statistics?: StatisticsInApi;
    onStatisticsOpen?: () => void;
}

export const LiveEventDetailHeader = (props: ILiveEventDetailHeaderProps) => {
    const sportName = getSportClassByPresentationId(props.graphicsPresentationId);
    const [actionsToggleTrigger, setActionsToggleTrigger] = React.useState(0);

    React.useEffect(() => {
        if (__IsMTSTipos__ && props.canShowMatchTrackerIcon && props.onMatchTrackerClick) {
            props.onMatchTrackerClick();
        }
    }, []);

    const renderIcons = (doLeftMargin: boolean) => {
        return <div>
            {
                __IsMTS__ && props.statistics &&
                <span className={classNames("etip-stats cursor-pointer")} onClick={() => { props.onStatisticsOpen && props.onStatisticsOpen(); }}></span>
            }
            {
                (props.canShowMatchTrackerIcon) &&
                <i className={`fa fa-eye cursor-pointer ${doLeftMargin ? 'ml-2' : ''} ${!props.onMatchTrackerClick ? 'disabled' : ''}`}
                    onClick={(evt) => { evt.stopPropagation(); props.onMatchTrackerClick(); }}>
                </i>
            }
            {
                (props.canShowLiveStreamIcon) &&
                <i className={`fa fa-desktop cursor-pointer ${doLeftMargin ? 'ml-2' : ''} ${!props.onLiveStreamClick ? 'disabled' : ''}`}
                    onClick={(evt) => { evt.stopPropagation(); if (props.onLiveStreamClick) { props.onLiveStreamClick(); } }}>
                </i>
            }
        </div>
    }

    return (
        <div className={`live-event-detail-header desktop`}>
            <div className="event-breadcrumbs">{props.categoryBreadcrumbs}</div>

            <div className="event-sport-time">
                <div style={{ display: "flex" }}>
                    <CategoryIcon categoryIconId={props.graphicsPresentationId} />
                    <div className="game-state ml-2">{props.stateName}{props.eventTime != null && <span>, {props.eventTime}'</span>}</div>
                </div>
                {!props.hasResults /* Formula 1 */ && renderIcons(true)}
            </div>
            <EventResults
                eventId={props.eventId}
                competitors={props.competitors}
                graphicsPresentationId={props.graphicsPresentationId}
                importantResults={props.importantResults}
                hasResults={props.hasResults}
                mainResult={props.mainResult}
                otherResults={props.otherResults}
                onGoToEventDetail={props.onGoToEventDetail}
            />

            <OtherEventResults
                graphicsPresentationId={props.graphicsPresentationId}
                otherResults={props.otherResults}
            />
            <div className={`line`}></div>
            {
                props.hasResults /* for Formula 1, no results, no actions */ && <div className={`actions-wrapper ${sportName}-color`}>
                    <div className="time-actions-wrapper" onClick={() => {
                        setActionsToggleTrigger(new Date().getTime());
                    }}
                    >
                        <span className="fa fa-clock mr-2"></span>
                        <div className="event-action-title">{translation().live_TimelineDesktopTitle}:</div>
                        <EventActions
                            onToggle={props.onToggleActions}
                            actions={props.actions}
                            collapsedTitle={props.actions.length ? <EventActionItem {...props.actions[0]} /> : ""}
                            externalExpandTrigger={actionsToggleTrigger}
                        />
                    </div>
                    {renderIcons(true)}
                </div>
            }
        </div >
    )
}